/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MetadataQueryField {
    SOFTWARE_AMOUNT = 'software_amount',
    SSO_PROVIDER_AMOUNT = 'sso_provider_amount',
    SSO_APPS_AMOUNT = 'sso_apps_amount',
    SOFTWARE_AND_SSO_APPS_AMOUNT = 'software_and_sso_apps_amount',
    LICENCE_AMOUNT = 'licence_amount',
    COST = 'cost',
    OPTIMIZATION_AMOUNT = 'optimization_amount',
    ACCOUNT_AMOUNT = 'account_amount',
    SAVING_AMOUNT = 'saving_amount',
}
